<script>
  import WhiteButton from '../../routes/whiteButton.svelte';
  import { onMount, onDestroy } from 'svelte';
  let windowWidth;

  // Function to update window width
  function updateWidth() {
    windowWidth = window.innerWidth;
  }

  onMount(() => {
    // Update width on mount
    updateWidth();
    // Add event listener for window resize
    window.addEventListener('resize', updateWidth);

    // Initialize diameter
    updateDiameter();
    // Listen for resize to adjust diameter
    window.addEventListener('resize', updateDiameter);

    // Cleanup function
    return () => {
      window.removeEventListener('resize', updateWidth);
      window.removeEventListener('resize', updateDiameter);
    };
  });
</script>

<div class="split-screen">
  {#if windowWidth > 768}
  <div class="half">
    <div class="container">
      <img src="../images/logos/newsletter.svg" width="77px" height="77px">
      <h2>Join the Freedom Writers Newsletter</h2><br>
      <p class="text">Get news and updates about Erin Gruwell and the Freedom Writers.</p>
      <br>
      <WhiteButton
        text="GET UPDATES"
        link="https://freedomwritersfoundation.us14.list-manage.com/subscribe?u=2a54c535fa8a5a82aa3815934&id=187b32d4e3"
      />
    </div>
  </div>
  {/if}
  <div class="half">
    <div class="container">
      <!-- Your HTML content here for the right side -->
      <h2>Follow us on Social!</h2>
      <ul class="custom-list">
        <li class="facebook"><a href="https://www.facebook.com/freedomwritersfoundation">@freedomwritersfoundation</a></li>
        <li class="instagram"><a href="https://www.instagram.com/freedomwritersfoundation">@freedomwritersfoundation</a></li>
        <li class="twittercurrentlyx"><a href="https://www.twitter.com/freedomwriters">@freedomwriters</a></li>
      </ul>
    </div>
  </div>
</div>

<style>
.custom-list a {
    color: #fff; /* Set the link color to white */
    text-decoration: none; /* Optional: Removes the underline from links */
    transition: color 0.3s; /* Optional: Smooth color transition for hover effects */
  }

  .custom-list a:hover {
    color: #000; /* Optional: Lighter color on hover for better UI interaction */
  }
  .custom-list {
    list-style: none; /* Remove default list styling */
    padding: 0; /* Remove default padding */
    margin-top: 1rem; /* Remove default margin */
    display: flex; /* Display flex to center children horizontally */
    flex-direction: column; /* Stack children vertically */
    align-items: center; /* Center children horizontally */
    justify-content: center; /* Center children vertically (if the container has a fixed height) */
  }

  .custom-list li {
    display: flex; /* Use flexbox for horizontal alignment of icon and text */
    align-items: center; /* Center items vertically within each `li` */
    background-repeat: no-repeat;
    background-position: center;
    background-size: 25px 25px; /* Size of the SVG */
    margin-bottom: 14px; /* Space between items */
  }

  .custom-list li::before {
    content: '';
    display: block; /* Make sure the pseudo-element is a block for proper spacing */
    width: 25px; /* Width of the SVG */
    height: 25px; /* Height of the SVG */
    margin-right: 14px; /* Space between the SVG and the text */
  }

.custom-list .facebook::before {
  background-image: url('/images/logos/facebook-white.svg');
}
.custom-list .instagram::before {
  background-image: url('/images/logos/instagram-white.svg');
}
.custom-list .twittercurrentlyx::before {
  background-image: url('/images/logos/twitter-white.svg');
}
  .split-screen {
    display: flex;
    height: 343px;
  }

  .half {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f7931e;
    position: relative; /* Needed for the pseudo-element to position correctly */
  }

  /* Add a pseudo-element to the first .half for the white line */
  .half:first-child::after {
    content: '';
    position: absolute;
    right: 0;
    top: 3.4rem;
    bottom: 3.4rem;
    width: 1px; /* Width of the line */
    background-color: #fff; /* White color */
  }

  h2 {
  font-family: 'Oswald';
  size: 1.7rem;
  }

  .container {
    text-align: center;
    color: #fff;
    max-width: 80%; /* Adjust as needed for your content */
  }
  
  .text {
    /* Your text styles */
  }
   @media (max-width: 768px) {

    .half:first-child::after {
      content: none; /* Remove the divider on smaller screens */
    }

    .half {
      padding: 0; /* Adjust padding as needed */
      flex-basis: 100%; /* Make each half full width */
    }
  }
</style>